import { IS_LOCAL_NX_DEV } from "@bridgesplit/utils";

const DEBUG_WALLET_STORAGE_KEY = "loopscale_debug_wallet";
const DEBUG_MODE_STORAGE_KEY = "loopscale_debug_mode";
const DEBUG_REWARDS_STORAGE_KEY = "loopscale_debug_rewards";

// luke is a good test wallet LoTy38EiLYg85rWq5okYjNwzQECGbYa6uPcJPj8MHu2
// luke -> bs1PuRvB9rBBZkryBjADYvxc2qYh51EVW2fsb1uTiBN
// jason -> 67VABVhoSdcWy29XPHs4a9z99ggmWTgenLGxeWYo3o62
// jason -> PJU6yfZGRALLmstEAozLRAStz2t6RaXd48ttu5GVUpz
const localDevDebugWallet: string | null = null;

// E2E test debug wallet type definition (also defined in test type definitions)
interface E2EWindow extends Window {
    __E2E_DEBUG_WALLET__?: string;
}

// Check for E2E test debug wallet
function getE2EDebugWallet(): string | null {
    if (typeof window !== "undefined") {
        return (window as E2EWindow).__E2E_DEBUG_WALLET__ || null;
    }
    return null;
}

export function isDebugMode(): boolean {
    if (IS_LOCAL_NX_DEV) return true;
    if (typeof window === "undefined") return false;

    // Check URL param first
    if (new URLSearchParams(window.location.search).has("debug")) {
        return true;
    }

    // Check localStorage for persistent debug mode
    return localStorage.getItem(DEBUG_MODE_STORAGE_KEY) === "true";
}

export function setDebugMode(enabled: boolean): void {
    if (typeof window === "undefined") return;
    if (enabled) {
        localStorage.setItem(DEBUG_MODE_STORAGE_KEY, "true");
        return;
    }
    localStorage.removeItem(DEBUG_MODE_STORAGE_KEY);
}

function getStoredDebugWallet(): string | null {
    if (typeof window === "undefined") return null;
    return localStorage.getItem(DEBUG_WALLET_STORAGE_KEY)?.trim() || null;
}

export function setDebugWallet(wallet: string | null): void {
    if (typeof window === "undefined") return;
    const trimmedWallet = wallet?.trim() || null;
    if (trimmedWallet) {
        localStorage.setItem(DEBUG_WALLET_STORAGE_KEY, trimmedWallet);
    } else {
        localStorage.removeItem(DEBUG_WALLET_STORAGE_KEY);
    }
}

export function getDebugWallet(): string | null {
    if (!isDebugMode()) return null;

    return getE2EDebugWallet() || getStoredDebugWallet() || localDevDebugWallet;
}

export function getDebugRewardsEnabled(): boolean {
    if (!isDebugMode()) return false;
    if (typeof window === "undefined") return false;
    return localStorage.getItem(DEBUG_REWARDS_STORAGE_KEY) === "true";
}

export function setDebugRewardsEnabled(enabled: boolean): void {
    if (typeof window === "undefined") return;
    if (enabled) {
        localStorage.setItem(DEBUG_REWARDS_STORAGE_KEY, "true");
    } else {
        localStorage.removeItem(DEBUG_REWARDS_STORAGE_KEY);
    }
}
